import UiLabelSuperPoolPositionCell from "@/components/Ui/Label/SuperPool/PositionCell";
import useIsErc20Withdrawal from "@/hooks/tx-flow/useIsErc20Withdrawal";
import { SupText, SupChip, SupLoader } from "@repo/core-ui";
import { useStoredData } from "@/store/Context";
import useChainInfo from "@/hooks/useChainInfo";
import Image from "next/image";
import React from "react";

export default function Web3WithdrawChainAlert() {
  const storedData = useStoredData();
  const isErc20 = useIsErc20Withdrawal();

  const { isLoading, data: chainData } = useChainInfo(storedData.withdrawalChainId);

  return (
    storedData.withdrawalChainId && (
      <div className="inline-flex h-[60px] w-full items-center justify-center space-x-2 rounded-full bg-primary-25 p-4">
        <SupText variant="caption" className="inline-flex leading-4">
          Withdrawing {!isErc20 ? "SuperPositions" : <UiLabelSuperPoolPositionCell className="mx-1" isErc20={isErc20} />} from
        </SupText>
        {isLoading || !chainData ? (
          <SupLoader isSmall />
        ) : (
          <SupChip
            label={chainData.name}
            icon={<Image unoptimized={true} className="rounded-full bg-white" width={16} height={16} src={chainData.icon} alt={chainData.name} />}
            border
            type="square"
            borderStyle="dashed"
            iconType="square"
            small
          />
        )}
      </div>
    )
  );
}
